const rows = [
  { feature: "Processing Speed", fpc: "As fast as 24 hours", agency: "2–3 weeks minimum", win: "fpc" },
  { feature: "Appointment Required", fpc: "No appointment needed", agency: "Appointment required — limited availability", win: "fpc" },
  { feature: "Drive to Agency", fpc: "None — ship your docs", agency: "400+ miles to Seattle or Denver from Missoula", win: "fpc" },
  { feature: "Document Review", fpc: "Expert review catches errors", agency: "Errors returned unprocessed", win: "fpc" },
  { feature: "Dedicated Agent", fpc: "Personal agent on your case", agency: "No dedicated agent assigned", win: "fpc" },
  { feature: "Status Updates", fpc: "Daily calls & emails", agency: "No updates — check online only", win: "fpc" },
  { feature: "Government Shutdown Risk", fpc: "Not affected", agency: "Fully suspended", win: "fpc" },
  { feature: "Cost", fpc: "Service fee + government fee", agency: "Government fee + your travel cost", win: "neutral" },
  { feature: "Money-Back Guarantee", fpc: "Included — no additional cost", agency: "None", win: "fpc" },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Side by Side</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Regional Passport Agency
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            For Missoula residents, the nearest agency is 400+ miles away in Seattle or Denver. Here&apos;s why most choose Fast Passport Center instead.
          </p>
        </div>

        <div className="mb-8 bg-amber-50 border border-[#F6C344]/40 rounded-lg p-6">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">
            Missoula Passport Agency Appointment Not Available?
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Regional passport agency appointments are routinely booked 2–4 weeks out — and walk-ins are never accepted. If you searched for an appointment and came up empty, Fast Passport Center&apos;s registered courier channel is your fastest next step. No appointment. No waiting in line. Processing as fast as 2–3 business days.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr>
                <th className="text-left py-4 px-4 text-sm font-semibold text-gray-400 w-1/3">Feature</th>
                <th className="py-4 px-4 text-center w-1/3">
                  <span className="inline-flex items-center gap-2 text-sm font-bold text-white bg-[#1A365D] px-4 py-1.5 rounded-full whitespace-nowrap">
                    <i className="ri-shield-check-line text-[#F6C344]"></i> Fast Passport Center
                  </span>
                </th>
                <th className="py-4 px-4 text-center w-1/3">
                  <span className="text-sm font-semibold text-gray-400 whitespace-nowrap">Regional Passport Agency</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={`border-t border-gray-100 ${i % 2 === 0 ? "bg-[#F7F8FA]" : "bg-white"}`}>
                  <td className="py-4 px-4 text-sm font-medium text-gray-600">{row.feature}</td>
                  <td className="py-4 px-4 text-center">
                    <span className={`inline-flex items-center gap-1.5 text-sm font-semibold ${row.win === "fpc" ? "text-[#1A365D]" : "text-gray-500"}`}>
                      {row.win === "fpc" && <i className="ri-check-line text-green-500"></i>}
                      {row.fpc}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className={`inline-flex items-center gap-1.5 text-sm ${row.win === "fpc" ? "text-gray-400" : "text-gray-600"}`}>
                      {row.win === "fpc" && <i className="ri-close-line text-red-400"></i>}
                      {row.agency}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-8 py-4 rounded-md transition-all whitespace-nowrap"
          >
            Skip the Agency Trip — Start Now <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}